import CategoryDropdownL2 from "../../components/CategoryDropdownL2";
import ActivitiesInterface from "../activities/Activities";
import Selector from "../../components/Selector";
import useAuth from "../../hooks/useAuth";
import { useEffect, useState } from "react";
import NewAssignment from "../new_assignment/NewAssignment";
import ClassInterface from "../class_interface/ClassInterface";
import Button from "../../components/Button";
import ExitButton from "../../components/ExitButton";
import authFetch from "../../api/authFetch";

const TeacherInterface = ({successHandler, teacher = ""}) => {
    const {auth, setAuth} = useAuth();
    const [classes, setClasses] = useState([]);
    const [newTag, setTag] = useState("");
    const [newLang, setLang] = useState("Catalan (Central)");
    const [changeList, setChangeList] = useState([]);
    const [changedTags, setChangedTags] = useState([]);
    const [student, setStudent] = useState("");
    const [currentClass, setClass] = useState("");
    const [students, setStudents] = useState([]);
    const [page, setPage] = useState(1);
    const [pages, setPages] = useState(0);
    const tabs = ['Class management', 'User activities'];
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const [requests, setRequests] = useState([]);
    const [assignmentPage, setNewAssign] = useState(false);
    const [assignments, setAssignments] = useState([]);
    const [newClassError, setNewClasserror] = useState("");

    const fetchData = async (route, method) => {
        const response = await authFetch(`/teacher/${route}` + ((teacher !== "") ? `?teacher_name=${teacher}` : ""), {
            method: method
        });
        if (response.status === 401) {
            localStorage.removeItem("token");
            setAuth({});
            return null;
        }
        if (response.ok) {
            const json = await response.json();
            return json;
        }
        return null
    }

    const createClass = async (tag, lang) => {
        await fetchData(`create-class/${tag}/${lang}`, "POST");
    }

    const getClasses = async () => {
        const json = await fetchData("taught-classes", "GET");
        if (json) {
            setClasses(json);
        }
    }

    const deleteClass = async (tag) => {
        await fetchData(`delete-class/${tag}`, "DELETE");
    }

    const getTagError = async (tag) => {
        if (tag === "") {
            return "Name of class is required.";
        }
        for (let c of [" ", "/"]) {
            if (tag.includes(c)) {
                return `Name of class cannot include \"${c}\".`;
            }
        }
        const json = await fetchData(`tag-exists/${tag}`, "GET");
        if (json.exists) {
            return "You already have a class with this name";
        }
        return null;
    }

    const changeNewTag = async (tag) => {
        setTag(tag);
        setNewClasserror("");
        const error = await getTagError(tag);
        if (error) {
            setNewClasserror(error);
        }
    }

    const updateTag = async (oldTag, newTag) => {
        await fetchData(`update-tag/${oldTag}/${newTag}`, "POST");
    }

    const addStudent = async (tag, name) => {
        await fetchData(`add-user/${tag}/${name}`, "POST");
    }

    const getStudents = async () => {
        if (currentClass !== "") {
            const json = await fetchData(`students/${currentClass}/${page}`);
            if (json) {
                setStudents(json);
                getPages();
            }
        }
    }

    const getPages = async () => {
        const json = await fetchData(`pages/${currentClass}`, "GET");
        if (json) {
            setPages(json.pages);
        }
    }

    const removeStudent = async (tag, name) => {
        await fetchData(`remove-user/${tag}/${name}`, "DELETE");
    }

    const getRequests = async () => {
        const json = await fetchData("requests", "GET");
        if (json) {
            setRequests(json);
        }
    }

    const acceptRequest = async (request) => {
        const json = await fetchData(`accept-request/${request.tag}/${request.username}`, "POST");
        if (json) {
            getRequests();
            getStudents();
        }
    }

    const denyRequest = async (request) => {
        const json = await fetchData(`deny-request/${request.tag}/${request.username}`, "POST");
        if (json) {
            getRequests();
        }
    }

    const getAssignments = async () => {
        if (currentClass !== "") {
            const json = await fetchData(`assignments/${currentClass}`, "GET");
            if (json) {
                setAssignments(json);
                console.log(json);
            }
        }
    }

    const deleteAssignment = async (tag, title) => {
        await fetchData(`assignment/${tag}/${title}`, "DELETE");
    }

    const commit = async () => {
        for (const change of changeList) {
            const splits = change.action.split(" ");
            switch (splits[0]) {
                case "DELETE":
                    if (splits.length === 1) {
                        await deleteClass(change.class);   
                    } else {
                        await deleteAssignment(change.class, splits[1]);
                    }
                    break;
                case "CREATE":
                    await createClass(change.class, splits.slice(1).join(" "));
                    break;
                case "RENAME":
                    await updateTag(change.class, splits[1]);
                    break;
                case "ADD":
                    await addStudent(change.class, splits[1]);
                    break;
                case "REMOVE":
                    await removeStudent(change.class, splits[1]);
                    break;
                
            }
        }
        setChangeList([]);
        setChangedTags([]);
        getClasses();
        getStudents();
        getAssignments();
    }

    const removeChange = (i) => {
        let array = [...changeList];
        array.splice(i, 1);
        setChangeList(array);
    }

    const addChange = (change) => {
        setChangeList([...changeList, change]);
    }

    const addCreateClass = () => {
        setNewClasserror("");
        if (classes.map(course => course.tag).includes(newTag)) {
            setNewClasserror("Class with this name already exists.");
        } else if (newTag === "") {
            setNewClasserror("Name for class required");
        } else {
            addChange({
                class: newTag,
                action: `CREATE ${newLang}`
            });
        }
        setTag("");
    }

    const changeTag = (i, tag) => {
        let arr = changedTags.filter((el) => el.index !== i);
        arr.push({ index: i, tag: tag });
        setChangedTags(arr);
    };

    const addUpdateTag = (i, oldTag) => {
        addChange({
            class: oldTag,
            action: `RENAME ${changedTags.find((el) => el.index === i).tag}`
        });
    }

    const classPageHandler = (state) => {
        if (!state) {
            setClass("");
        }
    }

    useEffect(() => {getClasses()}, []);
    useEffect(() => {getRequests()}, []);
    useEffect(() => {getStudents()}, [currentClass, page]);
    useEffect(() => {getAssignments()}, [currentClass, assignmentPage]);

    if (currentClass !== "") {
        return <ClassInterface successHandler={state => classPageHandler(state)} course={`${(teacher !== "") ? teacher : auth?.username}/${currentClass}`} teacher={teacher} />
    }

    if (assignmentPage) {
        return <NewAssignment successHandler={state => setNewAssign(state)} tag={currentClass} teacher={teacher} />
    }

    return (
        <main className="page-shell">
            <div className="page-container">
            <div className="page-header">
                <ExitButton func={()=> {successHandler(false)}} />
                <div>
                    <p className="panel-heading">Teaching</p>
                    <h1 className="page-heading">{teacher ? `${teacher}'s dashboard` : "Teacher dashboard"}</h1>
                    <p className="page-subtitle">Create classes, review groups, and follow learner activity.</p>
                </div>
            </div>
            <div>
                {teacher === "" &&
                    <Selector
                        clickHandler={(tab_index) =>
                            {
                                setActiveTabIndex(tab_index);
                            }
                        } 
                        tabsData={tabs} 
                        active = {activeTabIndex}
                    />
                }
            </div>
            
            {tabs[activeTabIndex] === "Class management" &&
                <div className="management-grid">
                    <div className="panel-stack">
                        <form
                            className="panel panel-body panel-stack"
                            onSubmit={(event) => {
                                event.preventDefault();
                                addCreateClass();
                            }}
                        >
                            <div>
                                <h2 className="panel-heading">Create a class</h2>
                                <p className="page-subtitle">Choose a course and give the group a short, unique name.</p>
                            </div>
                            <label className="flex flex-col gap-2">
                                <span className="account-label">Language course</span>
                                <CategoryDropdownL2 selectHandler={e => setLang(e.target.value)} elValue={newLang} />
                            </label>
                        
                            <label className="flex flex-col gap-2">
                                <span className="account-label">Class name</span>
                                <input className="form-field" type="text" placeholder="Group or topic name" value={newTag} onChange={e => changeNewTag(e.target.value)} />
                            </label>
                            {newClassError && <div className="text-sm font-semibold text-red-600">{newClassError}</div>}
                            <Button text="Create class" type="submit" />

                        </form>

                        {(changeList?.length>0)&&
                            <section className="notice-panel panel-stack">
                                <div className="flex items-center justify-between">
                                    <h2 className="panel-heading">Pending changes</h2>
                                    <span className="status-pill !bg-amber-100 !text-amber-800">{changeList.length}</span>
                                </div>
                                {changeList.map((change, i) => {
                                    return (<div className="list-row" key={`${change.class}-${change.action}-${i}`}>
                                        <div>
                                            <div className="font-bold text-cyan-950">{change.class}</div>
                                            <div className="text-xs text-slate-500">{change.action}</div>
                                        </div>
                                        <Button text="Remove" func={() => {removeChange(i)}} variant="ghost"/>
                                    </div>)
                                })}
                                <Button text="Apply changes" func={commit} />
                            </section>
                        }
                    </div>
                    <section className="panel panel-body">
                        <div className="mb-4 flex items-center justify-between">
                            <h2 className="panel-heading">Your classes</h2>
                            <span className="status-pill">{classes.length}</span>
                        </div>
                        <div className="selection-list">
                            {classes.map((course, i) => {
                                return (
                                    <div className="list-row" key={`${course.tag}-${i}`}>
                                        <div className="min-w-0">
                                            <div className="truncate font-bold text-cyan-950">{course.tag}</div>
                                            <div className="text-xs text-slate-500">{course.lang}</div>
                                        </div>
                                        {changedTags.map(change => change.index).includes(i) &&
                                            <Button text="Update name" func={() => addUpdateTag(i, course.tag)} />
                                        }
                                        <Button text="Open class" func={() => setClass(course.tag)} variant="secondary" />
                                    </div>
                                )
                            })}
                            {classes.length === 0 && <div className="empty-state">Create your first class to get started.</div>}
                        </div>
                    </section>
                </div>
            }
            {tabs[activeTabIndex] === "User activities" &&
                <div className="panel panel-body mt-4">
                    <ActivitiesInterface tabs={classes.map(course => course.tag)} />
                </div>
            }
            </div>
        </main>
    )
}

export default TeacherInterface;
